import * as React from 'react';
import { CallbackWidget } from '@cian/callback-widget';
import { useDispatch, useSelector } from 'react-redux';

import { requestCallback } from '../../../browser/services/callbackRequest';
import { closeRequestCallbackPopup } from '../../actions/requestCallback';
import { getUser } from '../../selectors/analytics';
import { getBuilder, getGaLabel } from '../../selectors/newbuilding';
import { getIsRequestCallbackOpen, getRequestCallbackOpener } from '../../selectors/requestCallback';
import { getUserPhone } from '../../selectors/user';
import { IRequestCallbackParams, TRequestCallbackOpener } from '../../types/requestCallback';
import { getWorkTime } from '../../utils/getWorkTime';
import { getPhoneString } from '../../utils/text';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { getPrivacyPolicyUrl } from './helpers';
import { trackSendCallbackRequest } from './tracking';

export function CallbackPopupContainer() {
  const { config } = useApplicationContext();

  const isPopupOpened = useSelector(getIsRequestCallbackOpen);
  const builder = useSelector(getBuilder);
  const gaLabel = useSelector(getGaLabel);
  const opener = useSelector(getRequestCallbackOpener);
  const user = useSelector(getUser);
  const userPhone = useSelector(getUserPhone);
  const dispatch = useDispatch();

  const callbackPhone = builder ? getPhoneString(builder.phone) : null;
  const workTime = getWorkTime(builder);
  const privacyPolicyUrl = getPrivacyPolicyUrl(config);

  const onClose = React.useCallback(() => {
    dispatch(closeRequestCallbackPopup());
  }, [dispatch]);

  const onRequestCallback = React.useCallback(
    async (parameters: IRequestCallbackParams) => {
      const result = await requestCallback(parameters);

      const extra: Record<string, string | boolean> = {
        call_now: parameters.callRightNow,
        call_time: parameters.time,
        phone: parameters.customerPhone,
      };

      trackSendCallbackRequest({
        label: gaLabel,
        placeType: opener as TRequestCallbackOpener,
        user: { ...user, extra },
      });

      return result;
    },
    [gaLabel, user, opener],
  );

  if (!callbackPhone) {
    return null;
  }

  return (
    <CallbackWidget
      agentPhone={callbackPhone}
      callFrom={workTime.callFrom}
      callTo={workTime.callTo}
      onClose={onClose}
      onRequestCallback={onRequestCallback}
      open={isPopupOpened}
      privacyPolicyUrl={privacyPolicyUrl}
      timezoneOffset={workTime.timezone}
      userPhoneNumber={userPhone}
    />
  );
}
